import {
  EXTEND_CHECK_TEXT,
  EXTEND_TERM_SCREEN_HEADING,
} from "components/ExtendRemainingTerm/ExtendTerm.const";
import {
  CRH_EXTEND_TERM,
  CRH_WITHOUT_EXTEND_TERM,
  CIRH_EXTEND_TERM,
  CIRH_WITHOUT_EXTEND_TERM,
  CRH_CHKBOX_TEXT,
  CRH_EXTEND_TERM_CHKBOX_TEXT,
  CIRH_EXTEND_TERM_CHKBOX_TEXT,
  CIRH_CHKBOX_TEXT,
} from "components/RequestRepaymentHoliday/RequestRepaymentHoliday.const";
import { RepaymentOptionType } from "./indicativeRepaymentOptions";

export const displayOptionsSubHeading = (
  repaymentOptionType: RepaymentOptionType
) => {
  switch (repaymentOptionType) {
    case RepaymentOptionType.CRHExtendTerm:
      return CRH_EXTEND_TERM;
    case RepaymentOptionType.CRHWithoutExtendTerm:
      return CRH_WITHOUT_EXTEND_TERM;
    case RepaymentOptionType.CIRHExtendTerm:
      return CIRH_EXTEND_TERM;
    case RepaymentOptionType.CIRHWithoutExtendTerm:
      return CIRH_WITHOUT_EXTEND_TERM;
    case RepaymentOptionType.ExtendTerm:
      return EXTEND_TERM_SCREEN_HEADING;
    default:
      return "";
  }
};
export const getCheckBoxText = (repaymentOptionType: RepaymentOptionType) => {
  switch (repaymentOptionType) {
    case RepaymentOptionType.CRHExtendTerm:
      return CRH_EXTEND_TERM_CHKBOX_TEXT;
    case RepaymentOptionType.CRHWithoutExtendTerm:
      return CRH_CHKBOX_TEXT;
    case RepaymentOptionType.CIRHExtendTerm:
      return CIRH_EXTEND_TERM_CHKBOX_TEXT;
    case RepaymentOptionType.CIRHWithoutExtendTerm:
      return CIRH_CHKBOX_TEXT;
    case RepaymentOptionType.ExtendTerm:
      return EXTEND_CHECK_TEXT;
    default:
      return "";
  }
};
